// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__27F7e","item":"PaymentsMobile_item__2uvi_","label":"PaymentsMobile_label__NL-LW","amount":"PaymentsMobile_amount__1doJQ"};